import React from 'react';
import PropTypes from 'prop-types';
import classes from '../scripts.module.scss';
import { statuses } from '../../../../utils/data/data';

const ScriptsStatusBar = ({ activeStatuses, onClick, unclickable }) => {
  let count = statuses.length;

  const wrapperCls = [classes.script_status_wrapper];

  if (unclickable) wrapperCls.push(classes.unclickable);

  return (
    <div className={wrapperCls.join(' ')}>
      <ul className={classes.status_list_wrapper}>
        {statuses.map((d) => (
          <li
            onClick={() => onClick(d.name)}
            style={{ zIndex: `${count--}` }}
            key={d.name}
            className={`${classes.script_status} ${activeStatuses.includes(d.name) ? classes.active : ''}`}
          >
            <div className={classes.script_status_content}>
              {d.icon}

              <span className={classes.script_status_text}>{d.name}</span>
            </div>
          </li>
        ))}
      </ul>

      <div className={classes.status_line} />
    </div>
  );
};

ScriptsStatusBar.propTypes = {
  activeStatuses: PropTypes.array.isRequired,
  onClick: PropTypes.func.isRequired,
  unclickable: PropTypes.bool,
};

ScriptsStatusBar.defaultProps = {
  unclickable: false,
};

export default ScriptsStatusBar;
